const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const vrContainer = path.resolve('src/containers/VR/index.js')

  return createPage({
    path: router(route.path, {}),
    component: vrContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
